import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from "react-router-dom";
import classes from './Navbar.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUserAlt, faBriefcase, faSignature, faIdCard, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { useDarkmodeContext } from '../contexts/DarkmodeContext';

const Navbar = ({ resumeURI }) => {
    const [hamburger, setHamburger] = useState(false)
    const [showSideNav, setShowSideNav] = useState(false)
    const [scrollPosition, setScrollPosition] = useState(false);
    const location = useLocation();
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    const { darkMode } = useDarkmodeContext()
    

    // scroll position
    const handleScroll = () => {
        const position = window.scrollY;
        setScrollPosition(position > 650);
    };

    useEffect(() => {
        if (location.pathname === '/') {
            handleScroll();
            window.addEventListener('scroll', handleScroll, { passive: true });
        } else {
            setScrollPosition(true);
        }
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [location.pathname]);

    // ham menu
    function changeHamburgerHandler() {
        setHamburger(prevCheck => !prevCheck);
        setShowSideNav(prevCheck => !prevCheck)
    }

    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    if (hamburger) {
                        setHamburger(false);
                        setShowSideNav(false)
                    }
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            }; // eslint-disable-next-line
        }, [ref, hamburger]);
    }

    return (
        <div className={`${classes.navbar} ${darkMode && classes.dark}`}>
            <div className={classes.navbar_top}>
                <div className={`${classes.logo}`}>
                    <NavLink activeClassName={classes.active} to='/'>E</NavLink>
                </div>
                <div
                    ref={wrapperRef}
                    onClick={changeHamburgerHandler}
                    className={`${classes.menu_btn} ${hamburger && classes.open}`}
                >
                    {/* ${classes.open} */}
                    <div className={classes.menu_btn__burger}></div>
                </div>
            </div>
            <nav className={showSideNav ? `${classes.sidebar} ${classes.activee}` : classes.sidebar}>
                <ul style={{
                    marginTop: scrollPosition ? "20px" : "80px"
                }}>
                    <li><NavLink activeClassName={classes.activeX} to='/' exact><FontAwesomeIcon icon={faHome} className={classes.icons} /> Home</NavLink></li>
                    <li><NavLink activeClassName={classes.activeX} to='/about'><FontAwesomeIcon icon={faUserAlt} className={classes.icons} /> About</NavLink></li>
                    <li><NavLink activeClassName={classes.activeX} to='/work'><FontAwesomeIcon icon={faBriefcase} className={classes.icons} /> Works</NavLink></li>
                    <li><NavLink activeClassName={classes.activeX} to='/blog'><FontAwesomeIcon icon={faSignature} className={classes.icons} /> Blog</NavLink></li>
                    <li>
                        <NavLink activeClassName={classes.activeX} to='/contact'>
                            <FontAwesomeIcon icon={faIdCard} className={classes.icons} />
                            Contact
                        </NavLink>
                    </li>
                    <li className={scrollPosition ? classes.show : classes.hidden}>
                        <Link to={{ pathname: resumeURI }} target="_blank">
                            <FontAwesomeIcon icon={faFilePdf} className={classes.icons} />
                            Resume
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Navbar;